<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title" v-text="pageTitle">Customers</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <form-navigation-tabs
              :tabs="tabs"
              v-on:selected="setActive"
              :active="currentView"
            ></form-navigation-tabs>

            <div v-show="currentView == 'details'" key="details">
              <selectlist
                name="title_id"
                label="Title"
                v-model="form.title_id"
                :options="titles"
                :required="true"
                placeholder="Please Select"
                :show-error="form.errors.has('title')"
                :error-message="form.errors.get('title')"
              ></selectlist>

              <inputbox
                name="first_name"
                label="First Name"
                :required="true"
                :show-error="form.errors.has('first_name')"
                :error-message="form.errors.get('first_name')"
                placeholder="John"
                v-model="form.first_name"
              ></inputbox>

              <inputbox
                name="last_name"
                label="Last Name"
                :required="true"
                :show-error="form.errors.has('last_name')"
                :error-message="form.errors.get('last_name')"
                placeholder="Doe"
                v-model="form.last_name"
              ></inputbox>

              <date-of-birth
                :required="true"
                v-model="form.date_of_birth"
              ></date-of-birth>

              <inputbox
                name="occupation"
                label="Occupation"
                placeholder="e.g: Sales Assistant"
                v-model="form.occupation"
              ></inputbox>

              <selectlist
                name="security_question_id"
                label="Security Question"
                placeholder="Please Select"
                v-model="form.security_question_id"
                :options="security_questions"
                :required="true"
                :show-error="form.errors.has('security_question_id')"
                :error-message="form.errors.get('security_question_id')"
              ></selectlist>

              <inputbox
                name="security_question_answer"
                label="Security Question Answer"
                type="text"
                placeholder="Answer"
                v-model="form.security_question_answer"
              ></inputbox>

              <inputbox
                name="email_address"
                label="Email Address"
                type="email"
                :show-error="form.errors.has('email_address')"
                placeholder="john@example.com"
                :required="true"
                v-model="form.email"
              ></inputbox>
              <inputbox
                name="home_telephone"
                label="Home Telephone"
                type="text"
                placeholder="Home Telephone"
                v-model="form.home_telephone"
              ></inputbox>
              <inputbox
                name="work_telephone"
                label="Work Telephone"
                type="text"
                placeholder="Work Telephone"
                v-model="form.work_telephone"
              ></inputbox>
              <inputbox
                name="mobile_telephone"
                label="Mobile Telephone"
                type="text"
                placeholder="Mobile Telephone"
                v-model="form.mobile_telephone"
              ></inputbox>

              <address-lookup
                :address="address"
                v-on:address="setAddress"
                :enable-lookup="!form.errors.any()"
                :show-error="addressErrors"
                :required="true"
              ></address-lookup>

              <selectlist
                name="contact_method_id"
                label="Preferred Contact Method"
                v-model="form.contact_method_id"
                :options="contact_methods"
                :required="true"
                :show-error="form.errors.has('contact_method_id')"
                :error-message="form.errors.get('contact_method_id')"
              ></selectlist>

              <selectlist
                name="contact_time_id"
                label="Preferred Contact Time"
                placeholder="Please Select"
                v-model="form.contact_time_id"
                :options="contact_times"
                :required="true"
                :show-error="form.errors.has('contact_time_id')"
                :error-message="form.errors.get('contact_time_id')"
              ></selectlist>
            </div>
            <div v-show="currentView == 'company'" key="company">
              <inputbox
                name="company_name"
                label="Company Name"
                type="text"
                placeholder="Company"
                v-model="form.company_name"
              ></inputbox>
              <inputbox
                name="vat_number"
                label="VAT Number"
                type="text"
                placeholder="VAT Number"
                v-model="form.vat_number"
              ></inputbox>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    customer: {
      type: String
    }
  },

  data() {
    return {
      currentView: 'details',
      form: new window.Form({
        title_id: null,
        first_name: null,
        last_name: null,
        date_of_birth: window.DateManager.driverStartingDate(),
        occupation: null,
        security_question_id: null,
        security_question_answer: null,
        company_name: null,
        vat_number: null,
        email: null,
        home_telephone: null,
        work_telephone: null,
        mobile_telephone: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        contact_method_id: null,
        contact_time_id: null
      }),
      tabs: [
        {
          name: 'details',
          label: 'Details'
        },
        {
          name: 'company',
          label: 'Company'
        }
      ]
    };
  },

  computed: {
    pageTitle() {
      if (this.customer) {
        return `Update Customer: ${this.form.first_name} ${this.form.last_name}`;
      }

      return 'Create Customer';
    },

    addressErrors() {
      return {
        address_line_one: this.form.errors.has('address_line_one'),
        city: this.form.errors.has('city'),
        postcode: this.form.errors.has('postcode')
      };
    },

    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    },

    titles() {
      return this.$store.getters['Titles/all'];
    },

    security_questions() {
      return this.$store.getters['SecurityQuestions/all'];
    },

    contact_methods() {
      return this.$store.getters['ContactMethods/all'];
    },

    contact_times() {
      return this.$store.getters['ContactTimes/all'];
    }
  },

  mounted() {
    if (this.customer) {
      window.Ajax.get('/customers/' + this.customer)
        .then(response => {
          this.form.title_id = response.data.title_id;
          this.form.first_name = response.data.first_name;
          this.form.last_name = response.data.last_name;
          this.form.date_of_birth = response.data.date_of_birth
            ? window.DateManager.format(response.data.date_of_birth)
            : null;
          this.form.security_question_answer =
            response.data.security_question_answer;
          this.form.company_name = response.data.company_name;
          this.form.vat_number = response.data.vat_number;
          this.form.email = response.data.email;
          this.form.occupation = response.data.occupation;
          this.form.home_telephone = response.data.home_telephone;
          this.form.work_telephone = response.data.work_telephone;
          this.form.mobile_telephone = response.data.mobile_telephone;
          this.form.address_line_one = response.data.address_line_one;
          this.form.address_line_two = response.data.address_line_two;
          this.form.city = response.data.city;
          this.form.postcode = response.data.postcode;
          this.form.security_question_id = response.data.security_question_id;
          this.form.contact_method_id = response.data.contact_method_id;
          this.form.contact_time_id = response.data.contact_time_id;
        })
        .catch(error => {});
    }
  },

  methods: {
    setActive(view) {
      this.currentView = view;
    },

    hasAddress() {
      let fields = ['address_line_one', 'city', 'postcode'];
      let passed = true;
      fields.forEach(field => {
        if (passed) {
          if (!this.form[field]) {
            passed = false;
          }
        }
      });

      return passed;
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    submit() {
      if (this.customer) {
        this.form
          .put(`/customers/${this.customer}`)
          .then(response => {
            window.toastify.success(
              'Success',
              'The customer was updated successfully!'
            );
          })
          .catch(response => {
            window.toastify.error(
              'Error',
              'Please complete the required fields'
            );
          });
      } else {
        this.form
          .post('/customers')
          .then(response => {
            window.toastify.success(
              'Success',
              'The customer was created successfully!'
            );
            this.route('/customers/' + response.identifier);
          })
          .catch(response => {
            window.toastify.error(
              'Error',
              'Please complete the required fields'
            );
          });
      }
    }
  }
};
</script>
